import React, { JSX, useEffect, useState } from 'react';
// import Header from '../Header/TopHeader';
// import './ResetPassword.scss';
import { Button, Card, Col, Form, Input, Row, Modal } from 'antd';
import axios from 'axios';
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useNavigate } from 'react-router-dom';
import { BackendAPI } from '../axios';
import { useSearchParams } from "react-router-dom";
import { Spin } from "antd";
import { LoadingOutlined } from '@ant-design/icons';
import { EyeInvisibleOutlined, EyeOutlined, LockOutlined, ReloadOutlined, SoundOutlined, UserOutlined } from '@ant-design/icons';
import Header from './common/header';
import Footer from './common/footer';
import { Controller, set, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Section } from '../views/home';

const MySwal = withReactContent(Swal);

interface resetPasswordForm {
    npassword: string;
    cpassword: string;
    captcha?: string;
}

const labelStyle = {
    fontWeight: "bold",
    // padding: '0 10px',
    fontSize: '16px',
    // marginBottom: "8px",
};

function ResetPassword(): JSX.Element {
    const [active, setActive] = useState<Section>("home");
    // const [captchaText, setCaptchaText] = useState<string>('');
    const [captchaImage, setCaptchaImage] = useState('');
    const [captchaText, setCaptchaText] = useState('');
    // const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const est = searchParams.get("est");

    const navigate = useNavigate();

    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [refreshToken, setRefreshToken] = useState('');
    const [open, setOpen] = useState(false);
    const [userEmail, setUserEmail] = useState('');
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [loading1, setLoading1] = useState(false);

const validationSchema = Yup.object().shape({
  npassword: Yup.string()
    .required('New password is required')
    .min(8, 'Password must be at least 8 characters long')
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d).+$/,
      'Password must contain both letters and numbers'
    ),

  cpassword: Yup.string()
    .required('Confirm password is required')
    .oneOf(
      [Yup.ref('npassword')],
      'Confirm password must match new password'
    ),

  captcha: Yup.string()
    .required('Captcha is required')
    .test(
      'captcha-matches',
      'Incorrect captcha',
      (value) => value === captchaText
    ),
});
    const { control, watch, handleSubmit, formState: { errors, touchedFields, isSubmitted } } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'onTouched',
    });

    const onSubmit = async (data: any) => {
        setLoading1(true);
        console.log("Form Data: ", data);
        const url = `/user/savePassword`;
        const header = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${refreshToken}`,
            },
            params: {
                password: `${data.npassword}`,
                email: `${userEmail}`,
            },
        };
        try {
            const response = await BackendAPI.post(url, {}, header);
            if (response.data === 'Show login page') {
                MySwal.fire({
                    icon: 'success',
                    imageWidth: 100,
                    imageHeight: 100,
                    title: 'Password Updated!',
                    text: 'Your password has been changed successfully. Please check your email for confirmation.',
                    confirmButtonColor: "#4CAF50",
                    confirmButtonText: "OK",
                }).then(() => {
                    navigate('/');
                })
            } else if (response.data === 'Unable to update default password') {
                MySwal.fire({
                    icon: 'error',
                    imageWidth: 100,
                    imageHeight: 100,
                    title: 'Password Update Failed!',
                    text: 'Something went wrong. Please try again later.',
                    confirmButtonColor: "#4CAF50",
                    confirmButtonText: "OK",
                }).then(() => {
                    navigate('/');
                })
            }
            setIsModalOpen(false);
            setLoading1(false);
        } catch (error) {
            console.error('Error:', error);
            MySwal.fire({
                icon: 'error',
                imageWidth: 100,
                imageHeight: 100,
                title: 'Password Update Failed!',
                text: 'Something went wrong. Please try again later.',
            });
            setLoading1(false);
        }
    }
    const fetchCaptchaImage = async () => {
        const header = {
            headers: {
                "Content-Type": "application/json",
            },
        };
        const url = `/user/generate`;
        try {
            const response = await BackendAPI.get(url, header);
            //   const result = response.data;
            setCaptchaImage(response.data.base64Image);
            setCaptchaText(response.data.captchaText);
        } catch (error) {
            console.error('Error fetching total count:', error);
        }
    };

    const getForgetPasswordLink = async (est: string) => {
        const url = `/user/changePassword?est=${est}`;
        try {
            const response = await BackendAPI.get(url);

            // Check if the response is a valid email
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(response.data) ? response.data : null;
        } catch (error) {
            console.error("Error hitting reset API:", error);
            return null;
        }
    };

    useEffect(() => {
        const sections = document.querySelectorAll("section");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setActive(entry.target.id as Section);
                    }
                });
            },
            { threshold: 0.5 }
        );

        sections.forEach((section) => observer.observe(section));

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        const executeFunction = async () => {
            if (est) {
                const email = await getForgetPasswordLink(est);
                if (email) {
                    setUserEmail(email);
                    setLoading(false);
                    await fetchCaptchaImage();
                } else {
                    setLoading(false);
                    navigate("/");
                }
            } else {
                setLoading(false);
                navigate("/");
            }
        };
        const getRefreshToken = async () => {
            try {
                const response = await BackendAPI.get("/user/refresh-token", { withCredentials: true });
                setRefreshToken(response.data);
            } catch (error) {
            }
        };
        getRefreshToken();
        executeFunction();
    }, [est, navigate]);
    //  Reset Password End   =========================================================

    const handleToggleLoginPasswordVisibility = (field: string) => {
        switch (field) {
            case 'npassword':
                setShowNewPassword(!showNewPassword);
                break;
            case 'cpassword':
                setShowConfirmPassword(!showConfirmPassword);
                break;
        }
    };

    const handleOpen = () => {
        setOpen(true);
    };
const playCaptchaAudio = () => {
  if (!captchaText) return;
console.warn('Captcha not loaded');
  // Stop any ongoing speech
  window.speechSynthesis.cancel();

  const spokenText = captchaText
    .split('')
    .map(char => {
      if (/[a-z]/.test(char)) return `lowercase ${char}`;
      if (/[A-Z]/.test(char)) return `uppercase ${char}`;
      if (/[0-9]/.test(char)) return `digit ${char}`;
      return char;
    })
    .join(', ');

  const utterance = new SpeechSynthesisUtterance(spokenText);

  utterance.lang = 'en-US';
  utterance.rate = 0.6;   // very slow
  utterance.pitch = 1;
  utterance.volume = 1;

  window.speechSynthesis.speak(utterance);
};

    return (
        <>
            <Spin spinning={loading} size='large'>
                <div className="content-container">
                    <div style={{}} className={`content ${loading ? "blurred" : ""}`}>
                        <div id='skip_maincontent' className='aboutus' style={{}}>
                            <div>
                                <Header active={active} />
                            </div>
                            {/* <div className="aboutus-card-container" > */}

                            <div  >
                                <style>
                                    {`
                                                .ant-modal-mask {
                                                backdrop-filter: blur(10px);
                                                background-color: rgba(13, 5, 54, 0.25) !important;
                                                }
                                            `}
                                </style>
                                
                                    <Modal
                                        open={isModalOpen}
                                        //    onCancel={handleClose}
                                        aria-labelledby="parent-modal-title"
                                        aria-describedby="parent-modal-description"
                                        footer={null}
                                        closable={false}
                                        centered
                                        styles={{
                                            body: {
                                                background: '#dde8faff'
                                            }
                                        }}
                                    >
                                        <Spin spinning={loading1} delay={500} size='large'>
                                        <Card style={{ padding: '0px', minHeight: 360, justifySelf: 'center', borderRadius: '8px', width: '100%', background: '#eaf5ff' }}>
                                            <Form layout="vertical" onFinish={handleSubmit(onSubmit)} >
                                                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                                                    <h1 style={{ margin: '5px', }}>Reset Password</h1>
                                                </div>
                                                <Row>
                                                    <Col xs={22} md={22}>
                                                        <Form.Item
                                                            label={<span style={labelStyle}> New Password</span>}
                                                            validateStatus={errors.npassword ? 'error' : ''}
                                                            help={(touchedFields.npassword || isSubmitted) && errors.npassword ? errors.npassword.message : ''}
                                                        >
                                                            <Controller
                                                                name="npassword"
                                                                control={control}
                                                                render={({ field }) =>
                                                                    <div style={{ position: 'relative' }}>
                                                                        {/* Use LockOutlined for New Password */}
                                                                        <Input
                                                                            prefix={<LockOutlined style={{ fontSize: '22px' }} />}
                                                                            type={showNewPassword ? 'text' : 'password'}
                                                                            {...field}
                                                                            style={{ height: '40px', borderRadius: '6px 0 0 6px', borderRight: 'none' }}
                                                                            className="custom-placeholder"
                                                                            placeholder='Enter New Password'
                                                                        />
                                                                    </div>}
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={2} md={2} style={{ height: '31px', alignSelf: 'center' }}>
                                                        <Button type='text' style={{ borderRadius: '0 10px 10px 0', border: 'none', height: '40px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white', width: '-webkit-fill-available' }}
                                                            tabIndex={0}
                                                            onClick={() => setShowNewPassword((prev) => !prev)}
                                                            aria-label={showNewPassword ? 'Hide password' : 'Show password'}
                                                        >
                                                            {showNewPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                                                        </Button>
                                                    </Col>
                                                    <Col xs={22} md={22}>
                                                        <Form.Item
                                                            label={<span style={labelStyle}> Confirm Password</span>}
                                                            validateStatus={errors.cpassword ? 'error' : ''}
                                                            help={(touchedFields.cpassword || isSubmitted) && errors.cpassword ? errors.cpassword.message : ''}
                                                        >
                                                            <Controller
                                                                name="cpassword"
                                                                control={control}
                                                                render={({ field }) =>
                                                                    <div style={{ position: 'relative' }}>
                                                                        {/* Use a different icon for Confirm Password */}
                                                                        <Input
                                                                            prefix={<LockOutlined style={{ fontSize: '18px', }} />}  // You can change the color or style for differentiation
                                                                            type={showConfirmPassword ? 'text' : 'password'}
                                                                            {...field}
                                                                            style={{ height: '40px', borderRadius: '6px 0 0 6px', borderRight: 'none' }}
                                                                            className="custom-placeholder"
                                                                            placeholder='Confirm New Password'
                                                                        />
                                                                    </div>}
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={2} md={2} style={{ height: '31px', alignSelf: 'center' }}>
                                                        <Button type='text' style={{ borderRadius: '0 10px 10px 0', border: 'none', height: '40px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white', width: '-webkit-fill-available' }}
                                                            tabIndex={0}
                                                            onClick={() => setShowConfirmPassword((prev) => !prev)}
                                                            aria-label={showConfirmPassword ? 'Hide password' : 'Show password'}
                                                        >
                                                            {showConfirmPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                                                        </Button>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col xs={24} md={24} lg={24}>
                                                        <Row className='captcha-container'>
                                                                         <div style={{ marginBottom: 8, display: 'flex', gap: '6px', width: '100%', }}>
                                                                <div
                                                                    style={{
                                                                        color: "#fff",
                                                                        width: '100%',
                                                                        borderRadius: '10px',
                                                                        border: '2ps solid blue',
                                                                        // padding: "8px 16px",
                                                                        // borderRadius: 6,
                                                                        // fontWeight: 600,
                                                                        // letterSpacing: 3,
                                                                        // display: "inline-block",
                                                                        // marginBottom: 8
                                                                    }}
                                                                >
                                                                    <img src={`data:image/png;base64,${captchaImage}`} alt="CAPTCHA" style={{ width: '100%', height: '50px', borderRadius: '10px', border: '2px solid #1515b4' }} />
                                                                </div>

                                            <Button
                                                type="link"
                                                onClick={fetchCaptchaImage}
                                                style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', fontSize: '24px,', height: '50px', color: 'white', width: '12%', }}
                                            >
                                                <ReloadOutlined />
                                            </Button>
                                            <Button
                                                type="link"
                                                onClick={playCaptchaAudio}
                                                style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', fontSize: '24px,', height: '50px', color: 'white', width: '12%', }}
                                            >
                                                <SoundOutlined />
                                            </Button>
                                        </div>
                                                        </Row>
                                                    </Col>
                                                    <Col xs={24} md={24} lg={24}>
                                                        <Row >
                                                            <Col xs={24} sm={24} md={24} lg={24}>
                                                                <Form.Item
                                                                    // label={<span style={labelStyle}>Captcha</span>}
                                                                    validateStatus={errors.captcha ? 'error' : ''}
                                                                    help={(touchedFields.captcha || isSubmitted) && errors.captcha ? errors.captcha.message : ''}
                                                                >
                                                                    <Controller
                                                                        name="captcha"
                                                                        control={control}
                                                                        render={({ field }) => <Input {...field} style={{ height: '40px' }} className="custom-placeholder" placeholder='Enter Captcha' />}
                                                                    />
                                                                </Form.Item>
                                                            </Col>

                                                        </Row>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={24} sm={24} md={24} lg={24} style={{ textAlign: 'center' }}>
                                                        <Button type="primary" htmlType="submit" style={{ width: '100%',background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
                                                            Submit
                                                        </Button>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={24} sm={24} md={24} lg={24} style={{ textAlign: 'center' }}>
                                                        <Button type="primary" htmlType="submit" style={{ width: '100%', backgroundColor: 'orange', marginTop: '10px', color: 'white' }} onClick={() => navigate('/')}>
                                                            Back to Homepage
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </Card>
                                </Spin>
                                    </Modal>
                            </div>
                            {/* </div> */}

                        </div>
                        {/* <Footer style={{ textAlign: 'center' }}>
                        ©2025 Copyright: C-DAC Mumbai. All Rights Reserved
                    </Footer> */}
                    </div>
                </div>

            </Spin>
        </>
    );
}

export default ResetPassword;
